/* eslint-disable import/no-cycle */
import React, { useContext } from 'react';
import styled from 'styled-components';

import { ICard } from '../../../types/shared';

import { ReactMarkdownExtended } from '../../../utils/generic';
import { transformTemplate } from '../../../utils/string-utils';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { Body, H3 } from '../../../styles/generic';
import Spacings from '../../../styles/Spacings';

import { FormContext } from '../../organisms/contact-form/ContactFormContext';

interface Props {
  title: string;
  listItems: ICard[];
}

const IconListWrapper = ({ title, listItems }: Props) => {
  const formData = useContext(FormContext);

  return (
    <section>
      <NextStepCard>
        {title && <StyledH3>{title}</StyledH3>}
        {listItems.map((item, key) => {
          return (
            <InnerStep key={key}>
              {item.image && (
                <IconWrapper>
                  <Image src={item.image.file?.url} />
                </IconWrapper>
              )}
              <div>
                <StyledBodyBold>{item.title}</StyledBodyBold>
                {item.body && (
                  <StyledBodyLight>
                    <ReactMarkdownExtended>
                      {formData
                        ? transformTemplate(
                            item.body.childMarkdownRemark?.rawMarkdownBody,
                            formData
                          )
                        : item.body.childMarkdownRemark?.rawMarkdownBody}
                    </ReactMarkdownExtended>
                  </StyledBodyLight>
                )}
              </div>
            </InnerStep>
          );
        })}
      </NextStepCard>
    </section>
  );
};

export default IconListWrapper;

const NextStepCard = styled.div`
  background-color: ${Colors.white};
  box-shadow: ${({ theme }) => theme.elevations.abnElevationWell};
  padding: ${Spacings.S};

  ${mq.from.breakpoint.M`
    padding: ${Spacings.L};
  `}
`;

const InnerStep = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${Spacings.XS};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const IconWrapper = styled.div`
  display: block;
  flex-shrink: 0;
  height: 48px;
  margin-right: ${Spacings.S};
  width: 48px;
`;

const Image = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.S};
  margin-top: 0;
`;

const StyledBodyBold = styled(Body)`
  font-weight: 500;
`;

const StyledBodyLight = styled(Body)`
  color: ${Colors.abnNeutral500};
`;
